import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LawsuitSection from './LawsuitSection';
import GarnishmentSection from './GarnishmentSection';
import SetoffSection from './SetoffSections';
import GiftSection from './GiftSection';
import CharitySection from './CharitySection';
import LossSection from './LossSection';
import AttorneyPayments from './AttorneyPayments';
import CreditorAgentSection from './CreditorAgentSections';
import OtherTransactionsSection from './OtherTransactionsSection';
import TrustSection from './TrustSection';
import ClosedAccountsSection from './ClosedAccountsSection';
import SafetyDepositSection from './SafetyDepositSection';
import StorageUnitsSection from './StorageUnitsSection';
import BorrowedPropertySection from './BorrowedPropertySection';
import EnvViolationSection from './EnvViolationSection';
import GovHazmatReleaseSection from './GovHazmatReleaseSection';
import EnvLawsuitsSection from './EnvLawsuits';
import BusinessSection from './BusinessSection';
import FinancialStatementSection from './FinancialStatementSection';
import { generateSofa } from './SOFAPDFGenerator';
import MailingMatrixServiceSelector from '../components/MailingMatrixServiceSelector';

const API_URL = process.env.REACT_APP_API_URL
const token = localStorage.getItem('accessToken');
// Modal state for Prior Address

export default function SOFA() {
    const [priorModalOpen, setPriorModalOpen] = React.useState(false);
    const [primaryPriorModalOpen, setPrimaryPriorModalOpen] = React.useState(false);
    const [secondaryPriorModalOpen, setSecondaryPriorModalOpen] = React.useState(false);
    const [incomeModalOpen, setIncomeModalOpen] = useState(false);
const [newPriorAddress, setNewPriorAddress] = React.useState({
  street1: '', street2: '', city: '', state: '', zip_code: '',
  move_in_date: new Date().toISOString().slice(0,10), move_out_date: ''
});
  // State for generated SOFA data
  const [generatedSofaData, setGeneratedSofaData] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);

  // Handler for generating SOFA data from API
  async function handleGenerateSofa() {
    if (isGenerating) return; // guard against rapid double-clicks
    setIsGenerating(true);
    setError(null);
    try {
      const res = await fetch(`${API_URL}/cases/${caseId}/sofa-generate/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error('Failed to generate SOFA data');
      const sofaPayload = await res.json();

      // Keep state in sync for the rest of the UI, but DO NOT depend on it for the PDF call
      setGeneratedSofaData(sofaPayload);

      // Pass the freshly fetched payload directly to the PDF generator.
      // The generator requires an object that includes `.sofa`.
      const blob = await generateSofa(caseData, sofaPayload, data);
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = (data?.amended ? 'SOFA-amended.pdf' : 'SOFA.pdf');
      link.click();

    } catch (err) {
      setError(err.message);
    } finally {
      setIsGenerating(false);
    }
  }
const [insiderPayments, setInsiderPayments] = useState([]);
const [insiderModalOpen, setInsiderModalOpen] = useState(false);
const [newInsider, setNewInsider] = useState({
  insider_name: '',
  street1: '',
  street2: '',
  city: '',
  state: '',
  zip_code: '',
  amount_owing: '',
  reason_for_payment: '',
  amount_paid: '',
  payment_date: new Date().toISOString().slice(0,10)
});
// State for Insider Debts (Question 9)
const [insiderDebts, setInsiderDebts] = useState([]);
const [insiderDebtModalOpen, setInsiderDebtModalOpen] = useState(false);
const [newInsiderDebt, setNewInsiderDebt] = useState({
  insider_name: '',
  street1: '',
  street2: '',
  city: '',
  state: '',
  zip_code: '',
  amount_owing: '',
  reason_for_payment: '',
  amount_paid: '',
  payment_date: new Date().toISOString().slice(0,10)
});
const [editInsiderDebtModalOpen, setEditInsiderDebtModalOpen] = useState(false);
const [editInsiderDebtData, setEditInsiderDebtData] = useState(null);
const [data, setData] = useState({
      debtsD: [], // array of secured creditors
      debtsE: [], // array of priority creditors
      debtsF: [], // array of nonpriority unsecured creditors
      debtsG: [],
      notifyEF: [], // array of others to notify
      allDebts: [],
      caseInfo: {}, // case metadata: number, name, etc.
      amended: false,
      amendedReason: '',
      amendedCreditors: [],
      mailingMatrixService: null,
  });  
  const [showAmendedModal, setShowAmendedModal] = useState(false);
  const [amendedReason, setAmendedReason] = useState('');
  const [amendStep, setAmendStep] = useState(1);
  const [amendedCreditors, setAmendedCreditors] = useState([]);
  const [mailingMatrixService, setMailingMatrixService] = useState(null);
// Edit Insider Modal state
const [editInsiderModalOpen, setEditInsiderModalOpen] = useState(false);
const [editInsiderData, setEditInsiderData] = useState(null);
  const { caseId } = useParams();
const [creditors, setCreditors] = useState([]);
const [creditors2, setCreditors2] = useState([]);
   const [modalYearIndicator, setModalYearIndicator] = useState('');
   const [modalDebtorType, setModalDebtorType] = useState('');
   const [modalEmployment, setModalEmployment] = useState(true);
   const [modalBusiness, setModalBusiness] = useState(false);
   const [modalAmount, setModalAmount] = useState('');
   const [otherModalOpen, setOtherModalOpen] = useState(false);
const [modalOtherDescription, setModalOtherDescription] = useState('');
const [modalOtherAmount, setModalOtherAmount] = useState('');
  const [caseData, setCaseData] = useState(null);
  const [sofaResponse, setSofaResponse] = useState(null);
  const [incomeItems, setIncomeItems] = useState([]);
  const [otherIncomeItems, setOtherIncomeItems] = useState([]);
  // Recent Payments state
  const [recentPayments, setRecentPayments] = useState([]);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [newPaymentCreditorId, setNewPaymentCreditorId] = useState('');
  const [newPaymentAmount, setNewPaymentAmount] = useState('');
  const [newPaymentDate, setNewPaymentDate] = useState(new Date().toISOString().slice(0,10));
  // Compute recent payments within last 120 days after creditors are loaded
  useEffect(() => {
    // compute recent payments within last 120 days
    const cutoff = new Date();
    cutoff.setDate(cutoff.getDate() - 240);
    const payments = creditors.flatMap(c =>
      (c.payments || [])
        .filter(p => new Date(p.payment_date) >= cutoff)
        .map(p => ({
          creditorId: c.id,
          creditorName: c.name,
          accountType: c.account_type,
          paymentId: p.id,
          payment: p.payment,
          payment_date: p.payment_date,
        }))
    );
    setRecentPayments(payments);
  }, [creditors]);
  useEffect(() => {
  if (!sofaResponse) return;
  async function fetchInsiderPayments() {
    try {
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-insider-payments/?sofa_response=${sofaResponse.id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.ok) throw new Error('Failed to fetch insider payments');
      setInsiderPayments(await res.json());
    } catch (err) {
      setError(err.message);
    }
  }
  fetchInsiderPayments();
}, [sofaResponse]);
// Fetch Insider Debts (Question 9)
useEffect(() => {
  if (!sofaResponse) return;
  async function fetchInsiderDebts() {
    const res = await fetch(
      `${API_URL}/cases/${caseId}/sofa-insider-payment-debts/?sofa_response=${sofaResponse.id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (!res.ok) throw new Error('Failed to fetch insider debts');
    setInsiderDebts(await res.json());
  }
  fetchInsiderDebts();
}, [sofaResponse]);
  // Add a new payment
  async function handleSaveNewPayment() {
    try {
      const res = await fetch(
        `${API_URL}/case/${caseId}/creditors/${newPaymentCreditorId}/payments/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ payment: newPaymentAmount, payment_date: newPaymentDate }),
        }
      );
      if (!res.ok) throw new Error('Failed to add payment');
      const created = await res.json();
      const creditor = creditors.find(c => c.id === newPaymentCreditorId);
      setRecentPayments(prev => [
        ...prev,
        {
          creditorId: newPaymentCreditorId,
          creditorName: creditor ? creditor.name : '',
          paymentId: created.id,
          payment: created.payment,
          payment_date: created.payment_date,
        },
      ]);
      setPaymentModalOpen(false);
      setNewPaymentCreditorId('');
      setNewPaymentAmount('');
      setNewPaymentDate(new Date().toISOString().slice(0,10));
    } catch (err) {
      setError(err.message);
    }
  }

function openInsiderModal() {
  setNewInsider({
    insider_name: '',
    street1: '',
    street2: '',
    city: '',
    state: '',
    zip_code: '',
    amount_owing: '',
    reason_for_payment: '',
    amount_paid: '',
    payment_date: new Date().toISOString().slice(0,10)
  });
  setInsiderModalOpen(true);
}

// Modal helpers for Insider Debts (Question 9)
function openInsiderDebtModal() {
  setNewInsiderDebt({
    insider_name: '',
    street1: '', street2: '', city: '', state: '', zip_code: '',
    amount_owing: '', reason_for_payment: '',
    amount_paid: '', payment_date: new Date().toISOString().slice(0,10)
  });
  setInsiderDebtModalOpen(true);
}

function openEditInsiderDebtModal(item) {
  setEditInsiderDebtData({
    ...item,
    transactionId: item.transactions[0]?.id,
    amount_paid: item.transactions[0]?.payment_amount || '',
    payment_date: item.transactions[0]?.payment_date || ''
  });
  setEditInsiderDebtModalOpen(true);
}

// Save new insider payment
async function handleSaveNewInsider() {
  try {
    const res = await fetch(`${API_URL}/cases/${caseId}/sofa-insider-payments/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        ...newInsider,
        // remove sofa_response from front-end; backend will assign it
      })
    });
    if (!res.ok) throw new Error('Failed to add insider payment');
    const created = await res.json();
    setInsiderPayments(prev => [...prev, created]);
    setInsiderModalOpen(false);
  } catch (err) {
    setError(err.message);
  }
}

// Save new insider debt (Question 9)
async function handleSaveNewInsiderDebt() {
  try {
    const res = await fetch(
      `${API_URL}/cases/${caseId}/sofa-insider-payment-debts/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(newInsiderDebt)
      }
    );
    if (!res.ok) throw new Error('Failed to add insider debt');
    const created = await res.json();
    setInsiderDebts(prev => [...prev, created]);
    setInsiderDebtModalOpen(false);
  } catch (err) {
    setError(err.message);
  }
}

// Edit Insider Modal helpers
function openEditInsiderModal(item) {
  setEditInsiderData({
    ...item,
    transactionId: item.transactions[0]?.id,
    amount_paid: item.transactions[0]?.payment_amount || '',
    payment_date: item.transactions[0]?.payment_date || ''
  });
  setEditInsiderModalOpen(true);
}

async function handleSaveEditedInsider() {
  const { id, transactionId, amount_paid, payment_date, transactions, ...paymentFields } = editInsiderData;
  try {
    // 1. Update payment metadata (excluding amount_paid and payment_date)
    const payRes = await fetch(
      `${API_URL}/cases/${caseId}/sofa-insider-payments/${id}/`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(paymentFields),
      }
    );
    if (!payRes.ok) throw new Error('Failed to update insider payment record');
    const updatedPayment = await payRes.json();

    // 2. Update transaction record if it exists
    let updatedTransaction = null;
    if (transactionId) {
      const txRes = await fetch(
        `${API_URL}/cases/${caseId}/sofa-insider-payments/${id}/transactions/${transactionId}/`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ payment_amount: amount_paid, payment_date }),
        }
      );
      if (!txRes.ok) throw new Error('Failed to update insider transaction');
      updatedTransaction = await txRes.json();
    }

    // 3. Merge updated transaction into payment object for UI
    const merged = {
      ...updatedPayment,
      transactions: updatedPayment.transactions.map(tx =>
        tx.id === (updatedTransaction?.id || null) ? updatedTransaction : tx
      )
    };

    setInsiderPayments(prev => prev.map(i => i.id === merged.id ? merged : i));
    setEditInsiderModalOpen(false);
  } catch (err) {
    setError(err.message);
  }
}

// Save edited insider debt (Question 9)
async function handleSaveEditedInsiderDebt() {
  const { id, transactionId, transactions, ...fields } = editInsiderDebtData;
  try {
    // Send debt update including payment fields
    const res = await fetch(
      `${API_URL}/cases/${caseId}/sofa-insider-payment-debts/${id}/`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          ...fields,
          amount_paid: editInsiderDebtData.amount_paid,
          payment_date: editInsiderDebtData.payment_date
        })
      }
    );
    if (!res.ok) throw new Error('Failed to update insider debt');
    const updatedDebt = await res.json();
    // Update local state
    setInsiderDebts(prev => prev.map(d => d.id === updatedDebt.id ? updatedDebt : d));
    setEditInsiderDebtModalOpen(false);
  } catch (err) {
    setError(err.message);
  }
}

// Delete an insider debt (Question 9)
async function handleInsiderDebtDelete(id) {
  try {
    const res = await fetch(
      `${API_URL}/cases/${caseId}/sofa-insider-payment-debts/${id}/`,
      {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    if (!res.ok) throw new Error('Failed to delete insider debt');
    setInsiderDebts(prev => prev.filter(d => d.id !== id));
  } catch (err) {
    setError(err.message);
  }
}
      {/* Insider Payments Cards Section */}
      <section className="p-6 bg-white shadow-lg rounded mb-6">
        <h2 className="text-xl font-semibold mb-4">Question 7: Insider Payments</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {insiderPayments.map(item => (
            <div
              key={item.id}
              onClick={() => openEditInsiderModal(item)}
              className="p-4 bg-white shadow rounded cursor-pointer relative hover:shadow-lg transition-shadow"
            >
              <button
                onClick={e => { e.stopPropagation(); handleInsiderDelete(item.id); }}
                className="absolute top-2 right-2 text-red-600 hover:text-red-800"
              >
                {/* Trash Icon */}
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" clipRule="evenodd" d="M6 2a1 1 0 00-1 1v1H3a1 1 0 000 2h14a1 1 0 000-2h-2V3a1 1 0 00-1-1H6zM4 6v10a2 2 0 002 2h8a2 2 0 002-2V6H4zm3 2a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2 0zm4 0a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2 0z"/>
                </svg>
              </button>
              <div className="space-y-1">
                <p className="font-medium text-lg">{item.insider_name}</p>
                <p className="text-sm text-gray-600">
                  {item.street1}{item.street2 ? `, ${item.street2}` : ''}, {item.city}, {item.state} {item.zip_code}
                </p>
                <p className="text-sm">
                  <strong>Paid:</strong> ${item.transactions[0]?.payment_amount || '0.00'} on {item.transactions[0]?.payment_date || '—'}
                </p>
                <p className="text-sm">
                  <strong>Owing:</strong> ${item.amount_owing}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* Add Insider Payment Modal */}
      {insiderModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Add Insider Payment</h3>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Name</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={newInsider.insider_name}
                onChange={e => setNewInsider(prev => ({ ...prev, insider_name: e.target.value }))}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Street 1</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.street1}
                  onChange={e => setNewInsider(prev => ({ ...prev, street1: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Street 2</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.street2}
                  onChange={e => setNewInsider(prev => ({ ...prev, street2: e.target.value }))}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">City</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.city}
                  onChange={e => setNewInsider(prev => ({ ...prev, city: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">State</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.state}
                  onChange={e => setNewInsider(prev => ({ ...prev, state: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Zip Code</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.zip_code}
                  onChange={e => setNewInsider(prev => ({ ...prev, zip_code: e.target.value }))}
                />
              </div>
            </div>
            <div className="grid grid-cols-4 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Payment Amount</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.amount_paid}
                  onChange={e => setNewInsider(prev => ({ ...prev, amount_paid: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Payment Date</label>
                <input
                  type="date"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.payment_date}
                  onChange={e => setNewInsider(prev => ({ ...prev, payment_date: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Amount Owing</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.amount_owing}
                  onChange={e => setNewInsider(prev => ({ ...prev, amount_owing: e.target.value }))}
                />
              </div>
              <div />
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Reason for Payment</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={newInsider.reason_for_payment}
                onChange={e => setNewInsider(prev => ({ ...prev, reason_for_payment: e.target.value }))}
              />
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button
                onClick={() => setInsiderModalOpen(false)}
                className="px-4 py-2 bg-gray-200 rounded"
              >Cancel</button>
              <button
                onClick={handleSaveNewInsider}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >Save</button>
            </div>
          </div>
        </div>
      )}
      {/* Edit Insider Payment Modal */}
     {editInsiderModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Edit Insider Payment</h3>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Name</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={editInsiderData.insider_name}
                onChange={e => setEditInsiderData(prev => ({ ...prev, insider_name: e.target.value }))}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Street 1</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderData.street1}
                  onChange={e => setEditInsiderData(prev => ({ ...prev, street1: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Street 2</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderData.street2}
                  onChange={e => setEditInsiderData(prev => ({ ...prev, street2: e.target.value }))}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">City</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderData.city}
                  onChange={e => setEditInsiderData(prev => ({ ...prev, city: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">State</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderData.state}
                  onChange={e => setEditInsiderData(prev => ({ ...prev, state: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Zip Code</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderData.zip_code}
                  onChange={e => setEditInsiderData(prev => ({ ...prev, zip_code: e.target.value }))}
                />
              </div>
            </div>
            <div className="grid grid-cols-4 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Payment Amount</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderData.amount_paid}
                  onChange={e => setEditInsiderData(prev => ({ ...prev, amount_paid: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Payment Date</label>
                <input
                  type="date"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderData.payment_date}
                  onChange={e => setEditInsiderData(prev => ({ ...prev, payment_date: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Amount Owing</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderData.amount_owing}
                  onChange={e => setEditInsiderData(prev => ({ ...prev, amount_owing: e.target.value }))}
                />
              </div>
              <div />
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Reason for Payment</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={editInsiderData.reason_for_payment}
                onChange={e => setEditInsiderData(prev => ({ ...prev, reason_for_payment: e.target.value }))}
              />
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button onClick={() => setEditInsiderModalOpen(false)} className="px-4 py-2 bg-gray-200 rounded">
                Cancel
              </button>
              <button onClick={handleSaveEditedInsider} className="px-4 py-2 bg-blue-600 text-white rounded">
                Save
              </button>
            </div>
          </div>
        </div>
      )}

// Update an existing insider payment
async function handleInsiderChange(id, field, value) {
  try {
    const res = await fetch(
      `${API_URL}/cases/${caseId}/sofa-insider-payments/${id}/`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ [field]: value })
      }
    );
    if (!res.ok) throw new Error('Failed to update insider payment');
    const updated = await res.json();
    setInsiderPayments(prev => prev.map(i => i.id === id ? updated : i));
  } catch (err) {
    setError(err.message);
  }
}

// Delete an insider payment
async function handleInsiderDelete(id) {
  try {
    const res = await fetch(
      `${API_URL}/cases/${caseId}/sofa-insider-payments/${id}/`,
      {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    if (!res.ok) throw new Error('Failed to delete insider payment');
    setInsiderPayments(prev => prev.filter(i => i.id !== id));
  } catch (err) {
    setError(err.message);
  }
}
  // Delete an existing payment
  async function handleDeletePayment(creditorId, paymentId) {
    try {
      const res = await fetch(
        `${API_URL}/case/${caseId}/creditors/${creditorId}/payments/${paymentId}/`,
        {
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!res.ok) throw new Error('Failed to delete payment');
      setRecentPayments(prev => prev.filter(p => p.paymentId !== paymentId));
    } catch (err) {
      setError(err.message);
    }
  }
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const [primaryDebtor, setPrimaryDebtor] = useState(null);
    const [priorAddresses, setPriorAddresses] = useState([]);

    // Safely extract debt type (consumer vs. business)
    const debtType = caseData?.debt_type || '';

    // Handler for updating debt type via API
    async function handleDebtTypeChange(value) {
      try {
        const res = await fetch(
          `${API_URL}/case/${caseId}/debt-type/`,
          {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ debt_type: value }),
          }
        );
        if (!res.ok) throw new Error('Failed to update debt type');
        const updated = await res.json();
        setCaseData(prev => ({ ...prev, debt_type: updated.debt_type }));
      } catch (err) {
        setError(err.message);
      }
    }
  // Full names for primary and secondary debtors
  const primaryDebtorName = primaryDebtor
    ? `${primaryDebtor.first_name}${primaryDebtor.second_name ? ' ' + primaryDebtor.second_name : ''} ${primaryDebtor.last_name}`
    : '';
    const secondaryDebtor = caseData?.debtors?.find(d => d.is_filing && !d.is_primary);
  const secondaryDebtorName = secondaryDebtor
    ? `${secondaryDebtor.first_name}${secondaryDebtor.second_name ? ' ' + secondaryDebtor.second_name : ''} ${secondaryDebtor.last_name}`
    : '';
  // State for Income Items (no modal)
  const [newIncomeItem, setNewIncomeItem] = useState({
    employment_income: true,
    business_income: false,
    amount: ''
  });
  // group prior addresses by filing debtor
  
  const primaryAddresses = priorAddresses.filter(a => a.debtor === primaryDebtor?.id);
  const secondaryAddresses = secondaryDebtor
    ? priorAddresses.filter(a => a.debtor === secondaryDebtor.id)
    : [];
  
  // Safely extract debt type

  // Fetch or create SOFA response on mount
  useEffect(() => {
      async function fetchData() {
        try {
          const token = localStorage.getItem("accessToken");
          // Fetch case details and creditors in parallel
          const [caseRes, credRes] = await Promise.all([
            fetch(`${API_URL}/case/${caseId}/creditors/case-details/`, {
              headers: { Authorization: `Bearer ${token}` },
            }),
            fetch(`${API_URL}/case/${caseId}/creditors/`, {
              headers: { Authorization: `Bearer ${token}` },
            }),
          ]);
          if (!caseRes.ok || !credRes.ok) {
            console.error("Failed to fetch case or creditors");
            return;
          }
          const caseJson = await caseRes.json();
          const credJson = await credRes.json();
          // Populate data object
          setData({
            caseInfo: caseJson,
            debtsD: credJson.filter(d => d.debt_type === "secured"),
            debtsE: credJson.filter(d => d.debt_type === "priority"),
            debtsF: credJson.filter(d => d.debt_type === "unsecured"),
            debtsG: credJson.filter(d => d.debt_type === "executory"),
            notifyEF: credJson.filter(d => d.additional_notified),
            allDebts : credJson,
          });
          // Only keep id, name, and payments for recent payment UI
        const creditorList = credJson.map(c => ({
        id: c.id,
        name: c.account_name || c.name,
        account_type: c.account_type,      // <— add this
        payments: c.payments || [],
        }));
          setCreditors(creditorList);
                const creditorAddresses = credJson.map(c => ({
        name: c.account_name || c.name,
        street1: c.street1 || '',
        street2: c.street2 || '',
        city: c.city || '',
        state: c.state || '',
        zip_code: c.zip_code || '',
        codebtor: c.codebtor || '',
        codebtor_street1:c.codebtor_street1 || '',
        codebtor_street2:c.codebtor_street2 || '',
        codebtor_state:c.codebtor_state || '',
        codebtor_zip_code:c.codebtor_zip_code|| '',
        codebtor_city:c.codebtor_city||'',
      }));
      setCreditors2(creditorAddresses);
        } catch (err) {
          console.error("Error fetching schedule data:", err);
        } finally {
          setLoading(false);
        }
        
      }
      fetchData();
    }, [caseId, API_URL]);
  useEffect(() => {
    async function fetchOrCreateSofa() {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_URL}/cases/${caseId}/sofa-responses/`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!res.ok) {
          throw new Error('Failed to fetch SOFA response');
        }
        const list = await res.json();
        if (list.length) {
          setSofaResponse(list[0]);
        } else {
          // create new if none
          const createRes = await fetch(`${API_URL}/cases/${caseId}/sofa-responses/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify({ case: caseId }),
          });
          if (!createRes.ok) throw new Error('Failed to create SOFA response');
          const created = await createRes.json();
          setSofaResponse(created);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchOrCreateSofa();
  }, [caseId]);
  // Fetch case overview when caseId changes
  useEffect(() => {
    if (!caseId) return;
    async function fetchAll() {
      try {
        const caseRes = await fetch(`${API_URL}/case/${caseId}/overview/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!caseRes.ok) throw new Error("Couldn't load case overview");
        setCaseData(await caseRes.json());
      } catch (e) {
        console.error(e);
      }
    }
    fetchAll();
  }, [caseId]);

  // Fetch income items and other income items when sofaResponse is loaded
  useEffect(() => {
    if (!sofaResponse) return;

    async function fetchIncomeItems() {
      try {
        const incomeRes = await fetch(
          `${API_URL}/cases/${caseId}/sofa-income-items/?sofa_response=${sofaResponse.id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!incomeRes.ok) throw new Error('Failed to fetch income items');
        const incomeData = await incomeRes.json();
        setIncomeItems(incomeData);
      } catch (err) {
        setError(err.message);
      }
    }
    async function fetchOtherIncomeItems() {
      try {
        const otherRes = await fetch(
          `${API_URL}/cases/${caseId}/sofa-other-income-items/?sofa_response=${sofaResponse.id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!otherRes.ok) throw new Error('Failed to fetch other income items');
        const otherData = await otherRes.json();
        setOtherIncomeItems(otherData);
      } catch (err) {
        setError(err.message);
      }
    }

    fetchIncomeItems();
    fetchOtherIncomeItems();
  }, [sofaResponse?.id]);

  useEffect(() => {
    if (!caseData) return;
    // Only initialize primaryDebtor once
    if (!primaryDebtor) {
      const primary = caseData.debtors?.find(d => d.is_primary);
      setPrimaryDebtor(primary || null);
    }
  }, [caseData, primaryDebtor]);

  useEffect(() => {
    if (!caseData?.debtors) return;
    const filingDebtors = caseData.debtors.filter(d => d.is_filing);
    if (!filingDebtors.length) return;
    async function fetchPriorAddresses() {
      try {
        const allAddresses = [];
        for (const debtor of filingDebtors) {
          const res = await fetch(
            `${API_URL}/cases/${caseId}/debtors/${debtor.id}/prior-addresses/`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          if (!res.ok) throw new Error(`Failed to fetch prior addresses for debtor ${debtor.id}`);
          const data = await res.json();
          allAddresses.push(...data);
        }
        setPriorAddresses(allAddresses);
      } catch (err) {
        setError(err.message);
      }
    }
    fetchPriorAddresses();
  }, [caseData, caseId]);
async function handleDebtTypeChange(value) {
  try {
    const res = await fetch(
      `${API_URL}/case/${caseId}/debt-type/`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ debt_type: value }),
      }
    );
    if (!res.ok) throw new Error('Failed to update debt type');
    setCaseData(prev => ({ ...prev, debt_type: value }));
  } catch (err) {
    setError(err.message);
  }
}
  // Handle general response checkbox changes
  async function handleCheckboxChange(field) {
    if (!sofaResponse) return;
    const updatedValue = !sofaResponse[field];
    try {
      const res = await fetch(`${API_URL}/cases/${caseId}/sofa-responses/${sofaResponse.id}/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ [field]: updatedValue }),
      });
      if (!res.ok) throw new Error('Failed to update SOFA response');
      const updatedResponse = await res.json();
      setSofaResponse(updatedResponse);
    } catch (err) {
      setError(err.message);
    }
  }
async function handlePrimaryAddPriorAddress() {
  setNewPriorAddress({
    street1: '', street2: '', city: '', state: '', zip_code: '',
    move_in_date: new Date().toISOString().slice(0,10), move_out_date: ''
  });
  setPrimaryPriorModalOpen(true);
}
async function handleSecondaryAddPriorAddress() {
  setNewPriorAddress({
    street1: '', street2: '', city: '', state: '', zip_code: '',
    move_in_date: new Date().toISOString().slice(0,10), move_out_date: ''
  });
  setSecondaryPriorModalOpen(true);
}
async function handlePriorAddressChange(debtorId, id, field, value) {
  const res = await fetch(
    `${API_URL}/cases/${caseId}/debtors/${debtorId}/prior-addresses/${id}/`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ [field]: value })
    }
  );
  if (res.ok) {
    const updated = await res.json();
    setPriorAddresses(prev => prev.map(a => a.id === id ? updated : a));
  } else {
    setError('Failed to update prior address');
  }
}

async function handleDeletePriorAddress(debtorId, id) {
  const res = await fetch(
    `${API_URL}/cases/${caseId}/debtors/${debtorId}/prior-addresses/${id}/`,
    {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` }
    }
  );
  if (res.ok) setPriorAddresses(prev => prev.filter(a => a.id !== id));
  else setError('Failed to delete prior address');
}

// Save new prior address from modal
async function handleSaveNewPriorAddress(id) {
  try {
    const res = await fetch(
      `${API_URL}/cases/${caseId}/debtors/${id}/prior-addresses/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(newPriorAddress)
      }
    );
    if (!res.ok) throw new Error('Failed to add');
    const created = await res.json();
    setPriorAddresses(prev => [...prev, created]);
    setPrimaryPriorModalOpen(false);
    setSecondaryPriorModalOpen(false);
  } catch (err) {
    setError(err.message);
  }
}
  // Handlers for Income Items edits
  async function handleIncomeItemChange(id, field, value) {
    try {
      const res = await fetch(`${API_URL}/cases/${caseId}/sofa-income-items/${id}/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ [field]: value }),
      });
      if (!res.ok) throw new Error('Failed to update income item');
      const updatedItem = await res.json();
      setIncomeItems((items) =>
        items.map((item) => (item.id === id ? updatedItem : item))
      );
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleIncomeItemDelete(id) {
    try {
      const res = await fetch(`${API_URL}/cases/${caseId}/sofa-income-items/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
        method: 'DELETE',
      });
      if (!res.ok) throw new Error('Failed to delete income item');
      setIncomeItems((items) => items.filter((item) => item.id !== id));
    } catch (err) {
      setError(err.message);
    }
  }

  // Add new income item for a given year and debtor type
  async function handleAddIncomeItem(yearIndicator, debtorType) {
    if (!sofaResponse) return;
    try {
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-income-items/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            sofa_response: sofaResponse.id,
            year_indicator: yearIndicator,
            debtor_type: debtorType,
          }),
        }
      );
      if (!res.ok) throw new Error('Failed to add income item');
      const newItem = await res.json();
      setIncomeItems((items) => [...items, newItem]);
    } catch (err) {
      setError(err.message);
    }
  }
async function handleSaveNewOtherIncome() {
  if (!sofaResponse) return;
  try {
    const res = await fetch(
      `${API_URL}/cases/${caseId}/sofa-other-income-items/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          sofa_response: sofaResponse.id,
          year_indicator: modalYearIndicator,
          debtor_type: modalDebtorType,
          description: modalOtherDescription,
          amount: modalOtherAmount,
        }),
      }
    );
    if (!res.ok) throw new Error('Failed to add other income item');
    const newItem = await res.json();
    setOtherIncomeItems(items => [...items, newItem]);
    setOtherModalOpen(false);
  } catch (err) {
    setError(err.message);
  }
}
  // Handlers for Other Income Items edits
  async function handleOtherIncomeItemChange(id, field, value) {
    try {
      const res = await fetch(`${API_URL}/cases/${caseId}/sofa-other-income-items/${id}/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ [field]: value }),
      });
      if (!res.ok) throw new Error('Failed to update other income item');
      const updatedItem = await res.json();
      setOtherIncomeItems((items) =>
        items.map((item) => (item.id === id ? updatedItem : item))
      );
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleOtherIncomeItemDelete(id) {
    try {
      const res = await fetch(`${API_URL}/cases/${caseId}/sofa-other-income-items/${id}/`, {
        headers: { Authorization: `Bearer ${token}` },
        method: 'DELETE',
      });
      if (!res.ok) throw new Error('Failed to delete other income item');
      setOtherIncomeItems((items) => items.filter((item) => item.id !== id));
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleAddOtherIncomeItem() {
    if (!sofaResponse) return;
    try {
      const res = await fetch(`${API_URL}/cases/${caseId}/sofa-other-income-items/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ sofa_response: sofaResponse.id }),
      });
      if (!res.ok) throw new Error('Failed to add other income item');
      const newItem = await res.json();
      setOtherIncomeItems((items) => [...items, newItem]);
    } catch (err) {
      setError(err.message);
    }
  }

  // Handler for marital status update
  async function handleMaritalStatusChange(status) {
    // Optimistically update only the marital_status, preserving id and other fields
    setPrimaryDebtor(prev => ({ ...prev, marital_status: status }));

    // Ensure we have a valid debtor id before making the API call
    if (!primaryDebtor?.id) return;

    try {
      const res = await fetch(
        `${API_URL}/case/${caseId}/debtors/${primaryDebtor.id}/`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ marital_status: status }),
        }
      );
      if (!res.ok) throw new Error('Failed to update marital status');
      const updated = await res.json();

      // Update the caseData debtors array, preserving id and other fields
      setCaseData(prev => ({
        ...prev,
        debtors: prev.debtors.map(d =>
          d.id === primaryDebtor.id
            ? { ...d, marital_status: updated.marital_status }
            : d
        ),
      }));

      // Confirm UI state with the server-returned status
      setPrimaryDebtor(prev => ({ ...prev, marital_status: updated.marital_status }));
    } catch (err) {
      setError(err.message);
    }
  }

  // Handler for community property radio change
  async function handleCommunityPropertyChange(value) {
    if (!sofaResponse) return;
    // Optimistic update
    setSofaResponse(prev => ({ ...prev, community_property: value }));
    try {
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-responses/${sofaResponse.id}/`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ community_property: value }),
        }
      );
      if (!res.ok) throw new Error('Failed to update community property');
      const updated = await res.json();
      setSofaResponse(updated);
    } catch (err) {
      setError(err.message);
    }
  }

  // State for tracking if editing an insider payment
  const [editingInsider, setEditingInsider] = useState(false);

  // Handler for editing an insider payment (open modal with item)
  function handleInsiderEdit(item) {
    setEditingInsider(true);
    setNewInsider({
      id: item.id,
      insider_name: item.insider_name,
      street1: item.street1,
      street2: item.street2 || '',
      city: item.city,
      state: item.state,
      zip_code: item.zip_code,
      amount_owing: item.amount_owing,
      reason_for_payment: item.reason_for_payment,
      amount_paid: item.transactions?.[0]?.payment_amount || '',
      payment_date: item.transactions?.[0]?.payment_date || ''
    });
    setInsiderModalOpen(true);
  }

  // Handler for opening modal to add new insider payment
  function openInsiderModal() {
    setEditingInsider(false);
    setNewInsider({
      id: null,
      insider_name: '', street1: '', street2: '', city: '', state: '', zip_code: '',
      amount_owing: '', reason_for_payment: '',
      amount_paid: '', payment_date: ''
    });
    setInsiderModalOpen(true);
  }

  // Handler to update an existing insider payment
  async function handleUpdateInsider() {
    try {
      const {
        id, insider_name, street1, street2,
        city, state, zip_code, amount_owing,
        reason_for_payment, amount_paid, payment_date
      } = newInsider;
      const res = await fetch(
        `${API_URL}/cases/${caseId}/sofa-insider-payments/${id}/`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            insider_name, street1, street2, city, state,
            zip_code, amount_owing, reason_for_payment,
            amount_paid, payment_date
          }),
        }
      );
      if (!res.ok) throw new Error('Failed to update insider payment');
      const updated = await res.json();
      setInsiderPayments(prev => prev.map(item => item.id === id ? updated : item));
      setInsiderModalOpen(false);
    } catch (err) {
      setError(err.message);
    }
  }

  if (loading) return <div>Loading SOFA data...</div>;
  if (error) return <div style={{ color: 'red' }}>Error: {error}</div>;
  if (!sofaResponse) return <div>No SOFA response found.</div>;

  return (
    
    <div className="max-w-[1200px] mx-auto">
    {showAmendedModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow max-w-md w-full">
            {amendStep === 1 ? (
              <>
                <h3 className="text-lg font-semibold mb-2">Reason for Amendment</h3>
                <textarea
                  value={amendedReason}
                  onChange={e => setAmendedReason(e.target.value)}
                  className="w-full border rounded p-2"
                  rows={4}
                />
                <div className="mt-4 flex justify-end">
                  <button
                    onClick={() => setAmendStep(2)}
                    className="px-4 py-2 bg-blue-600 text-white rounded"
                  >
                    Next
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3 className="text-lg font-semibold mb-2">Select Creditors to Serve</h3>
                <MailingMatrixServiceSelector
                  caseId={caseId}
                  value={mailingMatrixService}
                  onChange={service => {
                    setMailingMatrixService(service);
                    setAmendedCreditors(
                      service?.enabled
                        ? (service.recipients || []).map(recipient => ({ ...recipient, method: service.method || 'USM' }))
                        : []
                    );
                  }}
                />
                {!mailingMatrixService?.enabled && <>
                <button
                  onClick={() =>
                    setAmendedCreditors(creditors2.map(c => ({ ...c, method: 'USM' })))
                  }
                  className="text-sm text-blue-600 mb-2"
                >
                  Select All as USM
                </button>
                <button
                  onClick={() => setAmendedCreditors([])}
                  className="ml-4 text-sm text-red-600 mb-2"
                >
                  Remove All
                </button>
                <div className="max-h-64 overflow-y-auto mb-4 border">
                  {creditors2.map((c, idx) => {
                    const selected = amendedCreditors.find(ac => ac.name === c.name);
                    return (
                      <div key={idx} className="flex items-center justify-between p-2 border-b">
                        <div className="flex-1">
                          <div className="font-medium">{c.name}</div>
                          <div className="text-sm text-gray-500">
                            {c.street1}{c.street2?.trim() ? `, ${c.street2}` : ''}, {c.city}, {c.state} {c.zip_code}
                          </div>
                        </div>
                        <select
                          value={selected?.method || ''}
                          onChange={e => {
                            const method = e.target.value;
                            setAmendedCreditors(prev => {
                              const exists = prev.find(ac => ac.name === c.name);
                              console.log(amendedCreditors)
                              if (exists) {
                                return prev.map(ac =>
                                  ac.name === c.name ? { ...ac, method } : ac
                                );
                              }
                              return [...prev, { ...c, method }];
                            });
                          }}
                          className="border rounded px-2 py-1"
                        >
                          <option value="">None</option>
                          <option value="USM">USM</option>
                          <option value="Certified">Certified</option>
                        </select>
                      </div>
                    );
                  })}
                </div>
                </>}
                <div className="flex justify-between">
                  <button
                    onClick={() => setAmendStep(1)}
                    className="px-4 py-2 bg-gray-200 rounded"
                  >
                    Back
                  </button>
                  <button
                    onClick={() => {
                      setShowAmendedModal(false);
                      setData({
                        ...data,
                        amendedReason,
                        amendedCreditors,
                        mailingMatrixService,
                      });
                      console.log(data)
                    }}
                    className="px-4 py-2 bg-green-600 text-white rounded"
                  >
                    Done
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {/* Button to generate SOFA data */}
                              <div className="flex items-center mb-4">
          <input
            type="checkbox"
            checked={data.amended}
            onChange={e => {
              const checked = e.target.checked;
              setData({ ...data, amended: checked });
              if (checked) {
                setShowAmendedModal(true);
                setAmendStep(1);
              }
            }}
            className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
          />
          <label className="ml-2 text-sm text-gray-700">Amended Filing</label>
        </div>
      <div className="flex justify-end mb-6">
        <button
          className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          onClick={handleGenerateSofa}
        >
          Generate SOFA JSON
        </button>
      </div>
      
     
      {/* Add Insider Debt Modal (Question 9) */}
      {insiderDebtModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Add Insider Debt Payment</h3>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Name</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={newInsiderDebt.insider_name}
                onChange={e => setNewInsiderDebt(prev => ({ ...prev, insider_name: e.target.value }))}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Street 1</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsiderDebt.street1}
                  onChange={e => setNewInsiderDebt(prev => ({ ...prev, street1: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Street 2</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsiderDebt.street2}
                  onChange={e => setNewInsiderDebt(prev => ({ ...prev, street2: e.target.value }))}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">City</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsiderDebt.city}
                  onChange={e => setNewInsiderDebt(prev => ({ ...prev, city: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">State</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsiderDebt.state}
                  onChange={e => setNewInsiderDebt(prev => ({ ...prev, state: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Zip Code</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsiderDebt.zip_code}
                  onChange={e => setNewInsiderDebt(prev => ({ ...prev, zip_code: e.target.value }))}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Payment Amount</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={newInsiderDebt.amount_paid}
                  onChange={e => setNewInsiderDebt(prev => ({ ...prev, amount_paid: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Payment Date</label>
                <input
                  type="date"
                  className="w-full border rounded px-2 py-1"
                  value={newInsiderDebt.payment_date}
                  onChange={e => setNewInsiderDebt(prev => ({ ...prev, payment_date: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Amount Owing</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={newInsiderDebt.amount_owing}
                  onChange={e => setNewInsiderDebt(prev => ({ ...prev, amount_owing: e.target.value }))}
                />
              </div>
              <div />
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Reason for Payment</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={newInsiderDebt.reason_for_payment}
                onChange={e => setNewInsiderDebt(prev => ({ ...prev, reason_for_payment: e.target.value }))}
              />
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button
                onClick={() => setInsiderDebtModalOpen(false)}
                className="px-4 py-2 bg-gray-200 rounded"
              >Cancel</button>
              <button
                onClick={handleSaveNewInsiderDebt}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >Save</button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Insider Debt Modal (Question 9) */}
      {editInsiderDebtModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Edit Insider Debt Payment</h3>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Name</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={editInsiderDebtData.insider_name || ''}
                onChange={e => setEditInsiderDebtData(prev => ({ ...prev, insider_name: e.target.value }))}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Street 1</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderDebtData.street1 || ''}
                  onChange={e => setEditInsiderDebtData(prev => ({ ...prev, street1: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Street 2</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderDebtData.street2 || ''}
                  onChange={e => setEditInsiderDebtData(prev => ({ ...prev, street2: e.target.value }))}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">City</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderDebtData.city || ''}
                  onChange={e => setEditInsiderDebtData(prev => ({ ...prev, city: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">State</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderDebtData.state || ''}
                  onChange={e => setEditInsiderDebtData(prev => ({ ...prev, state: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Zip Code</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderDebtData.zip_code || ''}
                  onChange={e => setEditInsiderDebtData(prev => ({ ...prev, zip_code: e.target.value }))}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Payment Amount</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderDebtData.amount_paid || ''}
                  onChange={e => setEditInsiderDebtData(prev => ({ ...prev, amount_paid: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Payment Date</label>
                <input
                  type="date"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderDebtData.payment_date || ''}
                  onChange={e => setEditInsiderDebtData(prev => ({ ...prev, payment_date: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Amount Owing</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={editInsiderDebtData.amount_owing || ''}
                  onChange={e => setEditInsiderDebtData(prev => ({ ...prev, amount_owing: e.target.value }))}
                />
              </div>
              <div />
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Reason for Payment</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={editInsiderDebtData.reason_for_payment || ''}
                onChange={e => setEditInsiderDebtData(prev => ({ ...prev, reason_for_payment: e.target.value }))}
              />
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button onClick={() => setEditInsiderDebtModalOpen(false)} className="px-4 py-2 bg-gray-200 rounded">
                Cancel
              </button>
              <button onClick={handleSaveEditedInsiderDebt} className="px-4 py-2 bg-blue-600 text-white rounded">
                Save
              </button>
            </div>
          </div>
        </div>
      )}

                      <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 1: Details about Marital Status and Addresses</h2>
      </div>
      <section className="p-6 bg-white shadow-lg rounded mb-6">
      

        <h2 className="text-xl font-semibold mb-4">Question 1: Marital Status</h2>
        {caseData?.debtors?.length === 2 ? (
          <div className="text-gray-700">
            Marital status is automatically <strong>Married</strong> for two debtors.
          </div>
        ) : (
          <div className="flex space-x-4">
            {['single','married','divorced','widowed','separated'].map(status => (
              <label key={status} className="flex items-center space-x-2">
                <input
                  type="radio"
                  name="marital_status"
                  value={status}
                  checked={primaryDebtor?.marital_status === status}
                  onChange={() => handleMaritalStatusChange(status)}
                  className="form-radio text-indigo-600"
                />
                <span className="capitalize">{status}</span>
              </label>
            ))}
          </div>
        )}
      </section>

      {/* Question 2: Prior Addresses */}
      <section className="p-2 sm:p-4 bg-white shadow-lg rounded mb-6">
        <h2 className="text-xl font-semibold mb-4">Question 2: Prior Addresses</h2>
        <p className="text-sm text-gray-600 mb-4">
          List all of the places you lived in the last 3 years. Do not include where you live now.
        </p>
        {primaryPriorModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-xl">
              <h3 className="text-lg font-semibold mb-4">Add Prior Address</h3>
              <div className="flex space-x-1 sm:space-x-2 mb-2 sm:mb-3">
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Street1</label>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.street1}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, street1: e.target.value }))}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Street2</label>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.street2}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, street2: e.target.value }))}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">City</label>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.city}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, city: e.target.value }))}
                  />
                </div>
              </div>
              <div className="flex space-x-1 sm:space-x-2 mb-2 sm:mb-3">
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">State</label>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.state}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, state: e.target.value }))}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Zip Code</label>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.zip_code}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, zip_code: e.target.value }))}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Move In</label>
                  <input
                    type="date"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.move_in_date}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, move_in_date: e.target.value }))}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Move Out</label>
                  <input
                    type="date"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.move_out_date}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, move_out_date: e.target.value }))}
                  />
                </div>
              </div>
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  onClick={() => setPrimaryPriorModalOpen(false)}
                  className="px-4 py-2 bg-gray-200 rounded"
                >Cancel</button>
                <button
                  onClick={() => handleSaveNewPriorAddress(primaryDebtor.id)}
                  className="px-4 py-2 bg-blue-600 text-white rounded"
                >Save</button>
              </div>
            </div>
          </div>
        )}
        {secondaryPriorModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-xl">
              <h3 className="text-lg font-semibold mb-4">Add Prior Address</h3>
              <div className="flex space-x-1 sm:space-x-2 mb-2 sm:mb-3">
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Street1</label>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.street1}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, street1: e.target.value }))}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Street2</label>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.street2}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, street2: e.target.value }))}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">City</label>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.city}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, city: e.target.value }))}
                  />
                </div>
              </div>
              <div className="flex space-x-1 sm:space-x-2 mb-2 sm:mb-3">
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">State</label>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.state}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, state: e.target.value }))}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Zip Code</label>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.zip_code}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, zip_code: e.target.value }))}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Move In</label>
                  <input
                    type="date"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.move_in_date}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, move_in_date: e.target.value }))}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">Move Out</label>
                  <input
                    type="date"
                    className="w-full border rounded px-2 py-1 sm:px-3 sm:py-2"
                    value={newPriorAddress.move_out_date}
                    onChange={e => setNewPriorAddress(prev => ({ ...prev, move_out_date: e.target.value }))}
                  />
                </div>
              </div>
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  onClick={() => setSecondaryPriorModalOpen(false)}
                  className="px-4 py-2 bg-gray-200 rounded"
                >Cancel</button>
                <button
                  onClick={() => handleSaveNewPriorAddress(secondaryDebtor.id)}
                  className="px-4 py-2 bg-blue-600 text-white rounded"
                >Save</button>
              </div>
            </div>
          </div>
        )}
        <div className={`grid grid-cols-1 ${secondaryDebtor ? 'md:grid-cols-2' : 'md:grid-cols-1'} gap-4`}>
          {/* Debtor 1 Column */}
          <div className={`${!secondaryDebtor ? 'md:w-2/3 md:mx-auto' : ''}`}>
            <h3 className="text-lg font-medium mb-2">
              Debtor&nbsp;1 ({primaryDebtorName})
            </h3>
            {primaryAddresses.length === 0
              ? <p>No prior addresses found.</p>
              : primaryAddresses.map(addr => (
                  <div key={addr.id} className="relative p-2 sm:p-4 bg-gray-100 shadow rounded mb-2 sm:mb-4 space-y-1 sm:space-y-2">
                    <div className="flex space-x-1 sm:space-x-2 mb-2 sm:mb-3">
                      {/* Street1, Street2, City */}
                      <div className="flex-1">
                        <label className="block text-sm font-medium mb-1">Street1</label>
                        <input
                          type="text"
                          className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                          value={addr.street1 || ''}
                          onChange={e =>
                            setPriorAddresses(prev =>
                              prev.map(a => a.id === addr.id ? { ...a, street1: e.target.value } : a)
                            )
                          }
                          onBlur={e => handlePriorAddressChange(primaryDebtor.id, addr.id, 'street1', e.target.value)}
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-sm font-medium mb-1">Street2</label>
                        <input
                          type="text"
                          className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                          value={addr.street2 || ''}
                          onChange={e =>
                            setPriorAddresses(prev =>
                              prev.map(a => a.id === addr.id ? { ...a, street2: e.target.value } : a)
                            )
                          }
                          onBlur={e => handlePriorAddressChange(primaryDebtor.id, addr.id, 'street2', e.target.value)}
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-sm font-medium mb-1">City</label>
                        <input
                          type="text"
                          className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                          value={addr.city || ''}
                          onChange={e =>
                            setPriorAddresses(prev =>
                              prev.map(a => a.id === addr.id ? { ...a, city: e.target.value } : a)
                            )
                          }
                          onBlur={e => handlePriorAddressChange(primaryDebtor.id, addr.id, 'city', e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="flex space-x-1 sm:space-x-2 mb-2 sm:mb-3">
                      {/* State, Zip, Move In, Move Out */}
                      <div className="flex-1">
                        <label className="block text-sm font-medium mb-1">State</label>
                        <input
                          type="text"
                          className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                          value={addr.state || ''}
                          onChange={e =>
                            setPriorAddresses(prev =>
                              prev.map(a => a.id === addr.id ? { ...a, state: e.target.value } : a)
                            )
                          }
                          onBlur={e => handlePriorAddressChange(primaryDebtor.id, addr.id, 'state', e.target.value)}
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-sm font-medium mb-1">Zip Code</label>
                        <input
                          type="text"
                          className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                          value={addr.zip_code || ''}
                          onChange={e =>
                            setPriorAddresses(prev =>
                              prev.map(a => a.id === addr.id ? { ...a, zip_code: e.target.value } : a)
                            )
                          }
                          onBlur={e => handlePriorAddressChange(primaryDebtor.id, addr.id, 'zip_code', e.target.value)}
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-sm font-medium mb-1">Move In</label>
                        <input
                          type="date"
                          className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                          value={addr.move_in_date || ''}
                          onChange={e =>
                            setPriorAddresses(prev =>
                              prev.map(a => a.id === addr.id ? { ...a, move_in_date: e.target.value } : a)
                            )
                          }
                          onBlur={e => handlePriorAddressChange(primaryDebtor.id, addr.id, 'move_in_date', e.target.value)}
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-sm font-medium mb-1">Move Out</label>
                        <input
                          type="date"
                          className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                          value={addr.move_out_date || ''}
                          onChange={e =>
                            setPriorAddresses(prev =>
                              prev.map(a => a.id === addr.id ? { ...a, move_out_date: e.target.value } : a)
                            )
                          }
                          onBlur={e => handlePriorAddressChange(primaryDebtor.id, addr.id, 'move_out_date', e.target.value)}
                        />
                      </div>
                    </div>
                    <button
                      onClick={() => handleDeletePriorAddress(primaryDebtor.id, addr.id)}
                      className="absolute top-2 right-2 text-red-600 hover:text-red-800"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" clipRule="evenodd" d="M6 2a1 1 0 00-1 1v1H3a1 1 0 000
                          2h14a1 1 0 000-2h-2V3a1 1 0 00-1-1H6zM4
                          6v10a2 2 0 002 2h8a2 2 0 002-2V6H4zm3
                          2a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2
                          0zm4 0a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0
                          00-2 0z"/>
                      </svg>
                    </button>
                  </div>
                ))
            }
            <button
              onClick={() => handlePrimaryAddPriorAddress()}
              className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            >
              Add Prior Address
            </button>
          </div>
          {/* Debtor 2 Column */}
          {secondaryDebtor && (
            <div>
              <h3 className="text-lg font-medium mb-2">
                Debtor&nbsp;2 ({secondaryDebtorName})
              </h3>
              {secondaryAddresses.length === 0
                ? <p>No prior addresses found.</p>
                : secondaryAddresses.map(addr => (
                    <div key={addr.id} className="relative p-2 sm:p-4 bg-gray-100 shadow rounded mb-2 sm:mb-4 space-y-1 sm:space-y-2">
                      <div className="flex space-x-1 sm:space-x-2 mb-2 sm:mb-3">
                        {/* Street1, Street2, City */}
                        <div className="flex-1">
                          <label className="block text-sm font-medium mb-1">Street1</label>
                          <input
                            type="text"
                            className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                            value={addr.street1 || ''}
                            onChange={e =>
                              setPriorAddresses(prev =>
                                prev.map(a => a.id === addr.id ? { ...a, street1: e.target.value } : a)
                              )
                            }
                            onBlur={e => handlePriorAddressChange(secondaryDebtor.id, addr.id, 'street1', e.target.value)}
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-sm font-medium mb-1">Street2</label>
                          <input
                            type="text"
                            className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                            value={addr.street2 || ''}
                            onChange={e =>
                              setPriorAddresses(prev =>
                                prev.map(a => a.id === addr.id ? { ...a, street2: e.target.value } : a)
                              )
                            }
                            onBlur={e => handlePriorAddressChange(secondaryDebtor.id, addr.id, 'street2', e.target.value)}
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-sm font-medium mb-1">City</label>
                          <input
                            type="text"
                            className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                            value={addr.city || ''}
                            onChange={e =>
                              setPriorAddresses(prev =>
                                prev.map(a => a.id === addr.id ? { ...a, city: e.target.value } : a)
                              )
                            }
                            onBlur={e => handlePriorAddressChange(secondaryDebtor.id, addr.id, 'city', e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="flex space-x-1 sm:space-x-2 mb-2 sm:mb-3">
                        {/* State, Zip, Move In, Move Out */}
                        <div className="flex-1">
                          <label className="block text-sm font-medium mb-1">State</label>
                          <input
                            type="text"
                            className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                            value={addr.state || ''}
                            onChange={e =>
                              setPriorAddresses(prev =>
                                prev.map(a => a.id === addr.id ? { ...a, state: e.target.value } : a)
                              )
                            }
                            onBlur={e => handlePriorAddressChange(secondaryDebtor.id, addr.id, 'state', e.target.value)}
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-sm font-medium mb-1">Zip Code</label>
                          <input
                            type="text"
                            className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                            value={addr.zip_code || ''}
                            onChange={e =>
                              setPriorAddresses(prev =>
                                prev.map(a => a.id === addr.id ? { ...a, zip_code: e.target.value } : a)
                              )
                            }
                            onBlur={e => handlePriorAddressChange(secondaryDebtor.id, addr.id, 'zip_code', e.target.value)}
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-sm font-medium mb-1">Move In</label>
                          <input
                            type="date"
                            className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                            value={addr.move_in_date || ''}
                            onChange={e =>
                              setPriorAddresses(prev =>
                                prev.map(a => a.id === addr.id ? { ...a, move_in_date: e.target.value } : a)
                              )
                            }
                            onBlur={e => handlePriorAddressChange(secondaryDebtor.id, addr.id, 'move_in_date', e.target.value)}
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-sm font-medium mb-1">Move Out</label>
                          <input
                            type="date"
                            className="mt-1 block w-full border border-gray-300 rounded px-2 py-1 sm:px-3 sm:py-2"
                            value={addr.move_out_date || ''}
                            onChange={e =>
                              setPriorAddresses(prev =>
                                prev.map(a => a.id === addr.id ? { ...a, move_out_date: e.target.value } : a)
                              )
                            }
                            onBlur={e => handlePriorAddressChange(secondaryDebtor.id, addr.id, 'move_out_date', e.target.value)}
                          />
                        </div>
                      </div>
                      <button
                        onClick={() => handleDeletePriorAddress(secondaryDebtor.id, addr.id)}
                        className="absolute top-2 right-2 text-red-600 hover:text-red-800"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" clipRule="evenodd" d="M6 2a1 1 0 00-1 1v1H3a1 1 0 000
                            2h14a1 1 0 000-2h-2V3a1 1 0 00-1-1H6zM4
                            6v10a2 2 0 002 2h8a2 2 0 002-2V6H4zm3
                            2a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2
                            0zm4 0a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0
                            00-2 0z"/>
                        </svg>
                      </button>
                    </div>
                  ))
              }
              <button
                onClick={() => handleSecondaryAddPriorAddress()}
                className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
              >
                Add Prior Address
              </button>
            </div>
          )}
        </div>
      </section>

      <section className="p-6 bg-white shadow-lg rounded mb-6">
        <h2 className="text-xl font-semibold mb-4">
          Question 3: Community Property
        </h2>
        <p className="text-sm text-gray-600 mb-4">
          Have you lived with a spouse in a community property state in the last 8 years? (Arizona, California, Idaho, Louisiana, Nevada, New Mexico, Puerto Rico, Texas, Washington, and Wisconsin)
        </p>
        <div className="flex space-x-4">
          {['yes', 'no'].map(option => (
            <label key={option} className="flex items-center space-x-2">
              <input
                type="radio"
                name="community_property"
                value={option}
                checked={sofaResponse.community_property === (option === 'yes')}
                onChange={() => handleCommunityPropertyChange(option === 'yes')}
                className="form-radio text-indigo-600"
              />
              <span className="capitalize">{option}</span>
            </label>
          ))}
        </div>
      </section>
                            <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 2: Details about your Income</h2>
      </div>
      {/* Question 4: Employment & Business Income */}
           {/* Question 4: Income Section */}
      <section className="p-6 bg-white shadow-lg rounded mb-6">
        <h2 className="text-xl font-semibold mb-4">Question 4: Employment Income Details</h2>
        <p className="text-sm text-gray-600 mb-4">
          Fill in the total amount of income you received from all jobs and all businesses, including part-time activities from the last 3 years.
        </p>
        <div className={`grid gap-6 ${secondaryDebtor ? 'md:grid-cols-2' : 'md:grid-cols-1'} max-w-3xl mx-auto`}>
          {[
            { label: `Debtor\u00A01 (${primaryDebtorName})`, type: 'debtor' },
            ...(secondaryDebtor ? [{ label: `Debtor\u00A02 (${secondaryDebtorName})`, type: 'debtor2' }] : [])
          ].map(({ label, type }) => (
            <div key={type}>
              <h3 className="text-lg font-medium mb-2">{label}</h3>
              {[
                { key: 'current', title: 'Current Year' },
                { key: 'previous', title: 'Previous Year' },
                { key: 'two_years', title: '2 Years Ago' }
              ].map(({ key, title }) => {
                const existing = incomeItems.find(i => i.debtor_type === type && i.year_indicator === key);
                return (
                  <div key={key} className="mb-4 p-4 border rounded shadow bg-white relative">
                    <div className="flex justify-between items-center mb-2">
                      <h4 className="font-semibold">{title}</h4>
                      {!existing && (
                        <button
                          onClick={() => {
                                setModalYearIndicator(key);
                                setModalDebtorType(type);
                                setModalEmployment(true);
                                setModalBusiness(false);
                                setModalAmount('');
                                setIncomeModalOpen(true);
                                }}
                          className="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                        >
                          Add Income
                        </button>
                      )}
                    </div>
                    {existing && (
                      <div className="flex items-center space-x-4">
                        <label className="flex items-center space-x-1">
                          <input
                            type="checkbox"
                            checked={existing.employment_income}
                            onChange={() =>
                              handleIncomeItemChange(
                                existing.id,
                                'employment_income',
                                !existing.employment_income
                              )
                            }
                            className="form-checkbox"
                          />
                          <span>Employment</span>
                        </label>
                        <label className="flex items-center space-x-1">
                          <input
                            type="checkbox"
                            checked={existing.business_income}
                            onChange={() =>
                              handleIncomeItemChange(
                                existing.id,
                                'business_income',
                                !existing.business_income
                              )
                            }
                            className="form-checkbox"
                          />
                          <span>Business</span>
                        </label>
                        <div className="flex items-center space-x-1 shadow rounded">
                          <span className="px-2">$</span>
                          <input
                            type="number"
                            step="0.01"
                            className="w-20 border-none px-2 py-1"
                            defaultValue={existing.amount || ''}
                            onBlur={e =>
                              handleIncomeItemChange(existing.id, 'amount', e.target.value)
                            }
                          />
                        </div>
                        <button
                          onClick={() => handleIncomeItemDelete(existing.id)}
                          className="absolute top-2 right-2 text-red-600 hover:text-red-800"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" clipRule="evenodd"
                              d="M6 2a1 1 0 00-1 1v1H3a1 1 0 000
                                 2h14a1 1 0 000-2h-2V3a1 1 0 00-1-1H6zM4
                                 6v10a2 2 0 002 2h8a2 2 0 002-2V6H4zm3
                                 2a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0
                                 00-2 0zm4 0a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0
                                 00-2 0z"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </section>
      {incomeModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-4 rounded shadow-lg w-full max-w-sm">
      <h3 className="text-lg font-semibold mb-4">Add Income</h3>
      <label className="flex items-center mb-2">
        <input
          type="checkbox"
          checked={modalEmployment}
          onChange={e => setModalEmployment(e.target.checked)}
          className="form-checkbox mr-2"
        />
        <span>Employment</span>
      </label>
      <label className="flex items-center mb-2">
        <input
          type="checkbox"
          checked={modalBusiness}
          onChange={e => setModalBusiness(e.target.checked)}
          className="form-checkbox mr-2"
        />
        <span>Business</span>
      </label>
      <label className="block mb-4">
        <span>Amount</span>
        <input
          type="number"
          step="0.01"
          className="w-full border rounded px-2 py-1"
          value={modalAmount}
          onChange={e => setModalAmount(e.target.value)}
        />
      </label>
      <div className="flex justify-end space-x-2">
        <button
          onClick={() => setIncomeModalOpen(false)}
          className="px-3 py-1 bg-gray-200 rounded"
        >
          Cancel
        </button>
        <button
          onClick={async () => {
            try {
              const res = await fetch(
                `${API_URL}/cases/${caseId}/sofa-income-items/`,
                {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify({
                    sofa_response: sofaResponse.id,
                    year_indicator: modalYearIndicator,
                    debtor_type: modalDebtorType,
                    employment_income: modalEmployment,
                    business_income: modalBusiness,
                    amount: modalAmount || 0,
                  }),
                }
              );
              if (!res.ok) throw new Error('Failed to add income item');
              const newItem = await res.json();
              setIncomeItems(items => [...items, newItem]);
              setIncomeModalOpen(false);
            } catch (err) {
              setError(err.message);
            }
          }}
          className="px-3 py-1 bg-indigo-600 text-white rounded"
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}
<section className="p-6 bg-white shadow-lg rounded mb-6">
  <h2 className="text-xl font-semibold mb-4">Question 5: Other Income</h2>
  <p className="text-sm text-gray-600 mb-4">
    Add other sources of income for the last 3 years (e.g. Social Security, Child Support, IRA Disbursement, Alimony, Unemployment, Pension, Rental Income, Interest, Dividends, Lawsuits, Royalties, Gambling).
  </p>
  <div className={`grid gap-6 ${secondaryDebtor ? 'md:grid-cols-2' : 'md:grid-cols-1'} max-w-3xl mx-auto`}>
    {[
      { label: `Debtor\u00A01 (${primaryDebtorName})`, type: 'debtor' },
      ...(secondaryDebtor ? [{ label: `Debtor\u00A02 (${secondaryDebtorName})`, type: 'debtor2' }] : [])
    ].map(({ label, type }) => (
      <div key={type}>
        <h3 className="text-lg font-medium mb-2">{label}</h3>
        {[
          { key: 'current', title: 'Current Year' },
          { key: 'previous', title: 'Previous Year' },
          { key: 'two_years', title: '2 Years Ago' }
        ].map(({ key, title }) => {
          const items = otherIncomeItems.filter(i => i.debtor_type === type && i.year_indicator === key);
          return (
            <div key={key} className="mb-4 p-4 border rounded shadow bg-white relative">
              <div className="flex justify-between items-center mb-2">
                <h4 className="font-semibold">{title}</h4>
                <button
                  onClick={() => {
                    setModalYearIndicator(key);
                    setModalDebtorType(type);
                    setModalOtherDescription('');
                    setModalOtherAmount('');
                    setOtherModalOpen(true);
                  }}
                  className="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                >
                  Add
                </button>
              </div>
              {items.length === 0 ? (
                <p className="text-sm text-gray-500">No entries.</p>
              ) : items.map(item => (
                <div key={item.id} className="flex items-center justify-between space-x-4 mb-2 p-2 bg-gray-100 rounded shadow">
                  <div className="flex-1">
                    <input
                      type="text"
                      value={item.description || ''}
                      onChange={e =>
                        setOtherIncomeItems(prev =>
                          prev.map(i =>
                            i.id === item.id ? { ...i, description: e.target.value } : i
                          )
                        )
                      }
                      onBlur={e => handleOtherIncomeItemChange(item.id, 'description', e.target.value)}
                      className="w-full border rounded px-2 py-1"
                    />
                  </div>
                  <div className="flex items-center space-x-1">
                    <span>$</span>
                    <input
                      type="number"
                      value={item.amount || ''}
                      onChange={e =>
                        setOtherIncomeItems(prev =>
                          prev.map(i =>
                            i.id === item.id ? { ...i, amount: e.target.value } : i
                          )
                        )
                      }
                      onBlur={e => handleOtherIncomeItemChange(item.id, 'amount', e.target.value)}
                      className="w-24 border rounded px-2 py-1"
                    />
                  </div>
                  <button onClick={() => handleOtherIncomeItemDelete(item.id)} className="text-red-600 hover:text-red-800">
                    &#10005;
                  </button>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    ))}
  </div>
  {otherModalOpen && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-md">
        <h3 className="text-lg font-semibold mb-4">Add Other Income</h3>
        <div className="mb-3">
          <label className="block text-sm font-medium mb-1">Description</label>
          <input
            list="other-income-options"
            value={modalOtherDescription}
            onChange={e => setModalOtherDescription(e.target.value)}
            className="w-full border rounded px-2 py-1"
          />
          <datalist id="other-income-options">
            <option value="Social Security" />
            <option value="VA Benefits" />
            <option value="Child Support" />
            <option value="Unemployment" />
            <option value="Food Stamps" />
            <option value="Alimony" />
            <option value="IRA Disbursement" />
            <option value="Pension" />
            <option value="Interest" />
            <option value="Dividends" />
            <option value="Lawsuit" />
            <option value="Royalties" />
            <option value="Gambling" />
          </datalist>
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Amount</label>
          <input
            type="number"
            value={modalOtherAmount}
            onChange={e => setModalOtherAmount(e.target.value)}
            className="w-full border rounded px-2 py-1"
          />
        </div>
        <div className="flex justify-end space-x-2">
          <button onClick={() => setOtherModalOpen(false)} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
          <button onClick={handleSaveNewOtherIncome} className="px-4 py-2 bg-blue-600 text-white rounded">Save</button>
        </div>
      </div>
    </div>
  )}
</section>
                      <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 3: Details about Recent Creditor Payments and Insider Payments</h2>
      </div>
      {/* Question 6: Consumer/Business Debt Type */}
      <section className="p-6 bg-white shadow-lg rounded mb-6">
        <h2 className="text-xl font-semibold mb-4">Question 6: Debt Type</h2>
        <p className="text-sm text-gray-600 mb-4">
          Select whether your debts are primarily consumer or business debts.
        </p>
        <div className="flex space-x-4">
          {caseData && ['consumer','business'].map(value => (
            <label key={value} className="flex items-center space-x-2">
              <input
                type="radio"
                name="debt_type"
                value={value}
                checked={debtType === value}
                onChange={() => handleDebtTypeChange(value)}
                className="form-radio text-indigo-600"
              />
              <span className="capitalize">{value}</span>
            </label>
          ))}
        </div>
        {/* Question 6b: Recent Payments to Creditors */}
        <h2 className="text-xl font-semibold mb-4 pt-6">Question 6b: Recent Payments to Creditors</h2>
        <p className="text-sm text-gray-600 mb-4">
          Have you paid a creditor more than $600 in the last 90 days. Do not include payments to attorneys or child support or alimony obligations.
        </p>
        {recentPayments.length === 0 ? (
          <p>No recent payments (last 120 days).</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            {recentPayments.map(rp => (
              <div key={`${rp.creditorId}-${rp.paymentId}`} className="relative p-4 bg-gray-100 shadow rounded">
                <button
                  onClick={() => handleDeletePayment(rp.creditorId, rp.paymentId)}
                  className="absolute top-2 right-2 text-red-600 hover:text-red-800"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" clipRule="evenodd" d="M6 2a1 1 0 00-1 1v1H3a1 1 0 000
                      2h14a1 1 0 000-2h-2V3a1 1 0 00-1-1H6zM4
                      6v10a2 2 0 002 2h8a2 2 0 002-2V6H4zm3
                      2a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2
                      0zm4 0a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0
                      00-2 0z"/>
                  </svg>
                </button>
                <h3 className="font-medium">{rp.creditorName}</h3>
                                <p className="mt-2">
                  <span className="font-semibold">Account type:</span> {rp.accountType}
                </p>
                <p className="mt-2">
                  <span className="font-semibold">Amount:</span> ${rp.payment}
                </p>
                <p>
                  <span className="font-semibold">Date:</span> {rp.payment_date}
                </p>
              </div>
            ))}
          </div>
        )}
        <button
          onClick={() => setPaymentModalOpen(true)}
          className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
        >
          Add Recent Payment
        </button>

        {paymentModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-md">
              <h3 className="text-lg font-semibold mb-4">Add Recent Payment</h3>
              <div className="mb-2">
                <label className="block text-sm font-medium mb-1">Creditor</label>
                <select
                  className="w-full border rounded px-2 py-1"
                  value={newPaymentCreditorId}
                  onChange={e => setNewPaymentCreditorId(e.target.value)}
                >
                  <option value="">Select creditor</option>
                  {creditors.map(c => (
                    <option key={c.id} value={c.id}>{`${c.name} (${c.account_type})`}</option>
                  ))}
                </select>
              </div>
              <div className="mb-2">
                <label className="block text-sm font-medium mb-1">Amount</label>
                <div className="flex items-center">
                  <span className="mr-1">$</span>
                  <input
                    type="number"
                    className="w-full border rounded px-2 py-1"
                    value={newPaymentAmount}
                    onChange={e => setNewPaymentAmount(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Payment Date</label>
                <input
                  type="date"
                  className="w-full border rounded px-2 py-1"
                  value={newPaymentDate}
                  onChange={e => setNewPaymentDate(e.target.value)}
                />
              </div>
              <div className="flex justify-end space-x-2">
                <button onClick={() => setPaymentModalOpen(false)} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
                <button onClick={handleSaveNewPayment} className="px-4 py-2 bg-blue-600 text-white rounded">Save</button>
              </div>
            </div>
          </div>
        )}
      </section>
      {/* Question 7: Insider Payments */}
<section className="p-6 bg-white shadow-lg rounded mb-6">
  <h2 className="text-xl font-semibold mb-4">Question 7: Insider Payments</h2>
  <p className="text-sm text-gray-600 mb-4">
    Include payments made in the last year on debts owed to relatives, general partners or their relatives, corporations or officers of those corporations that they hold 20% or more of and payments for DSOs.
  </p>
  <button
    onClick={openInsiderModal}
    className="mb-4 px-4 py-2 bg-blue-600 text-white rounded"
  >
    Add Insider Payment
  </button>
      {insiderModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">
              {editingInsider ? 'Edit Insider Payment' : 'Add Insider Payment'}
            </h3>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Name</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={newInsider.insider_name}
                onChange={e => setNewInsider(prev => ({ ...prev, insider_name: e.target.value }))}
              />
            </div>
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Street 1</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.street1}
                  onChange={e => setNewInsider(prev => ({ ...prev, street1: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Street 2</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.street2}
                  onChange={e => setNewInsider(prev => ({ ...prev, street2: e.target.value }))}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">City</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.city}
                  onChange={e => setNewInsider(prev => ({ ...prev, city: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">State</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.state}
                  onChange={e => setNewInsider(prev => ({ ...prev, state: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Zip Code</label>
                <input
                  type="text"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.zip_code}
                  onChange={e => setNewInsider(prev => ({ ...prev, zip_code: e.target.value }))}
                />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium mb-1">Payment Amount</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.amount_paid}
                  onChange={e => setNewInsider(prev => ({ ...prev, amount_paid: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Payment Date</label>
                <input
                  type="date"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.payment_date}
                  onChange={e => setNewInsider(prev => ({ ...prev, payment_date: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Amount Owing</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-full border rounded px-2 py-1"
                  value={newInsider.amount_owing}
                  onChange={e => setNewInsider(prev => ({ ...prev, amount_owing: e.target.value }))}
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">Reason for Payment</label>
              <input
                type="text"
                className="w-full border rounded px-2 py-1"
                value={newInsider.reason_for_payment}
                onChange={e => setNewInsider(prev => ({ ...prev, reason_for_payment: e.target.value }))}
              />
            </div>
            <div className="flex justify-end space-x-2 mt-4">
              <button
                onClick={() => setInsiderModalOpen(false)}
                className="px-4 py-2 bg-gray-200 rounded"
              >
                Cancel
              </button>
              <button
                onClick={editingInsider ? handleUpdateInsider : handleSaveNewInsider}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                {editingInsider ? 'Update' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
  {insiderPayments.length === 0 ? (
    <p>No insider payments found.</p>
  ) : (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4">
      {insiderPayments.map(item => {
        const tx = item.transactions?.[0] || {};
        return (
          <div
            key={item.id}
            className="relative p-4 bg-gray-100 shadow rounded cursor-pointer"
            onClick={() => handleInsiderEdit(item)}
          >
            <button
              onClick={e => { e.stopPropagation(); handleInsiderDelete(item.id); }}
              className="absolute top-2 right-2 text-red-600 hover:text-red-800"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" clipRule="evenodd" d="M6 2a1 1 0 00-1 1v1H3a1 1 0 000
                  2h14a1 1 0 000-2h-2V3a1 1 0 00-1-1H6zM4
                  6v10a2 2 0 002 2h8a2 2 0 002-2V6H4zm3
                  2a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2
                  0zm4 0a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0
                  00-2 0z"/>
              </svg>
            </button>
            <h3 className="font-medium">{item.insider_name}</h3>
            <p className="mt-2">
              <span className="font-semibold">Address:</span> {item.street1}{item.street2 ? `, ${item.street2}` : ''}, {item.city}, {item.state} {item.zip_code}
            </p>
            {tx.payment_amount && (
              <p className="mt-2">
                <span className="font-semibold">Paid:</span> ${tx.payment_amount}
              </p>
            )}
            <p className="mt-2">
              <span className="font-semibold">Owing:</span> ${item.amount_owing}
            </p>
            {tx.payment_date && (
              <p className="mt-2">
                <span className="font-semibold">Date:</span> {tx.payment_date}
              </p>
            )}
          </div>
        );
      })}
    </div>
  )}
</section>
 {/* Question 9: Payments on Insider Debts */}
      <section className="p-6 bg-white shadow-lg rounded mb-6">
        <h2 className="text-xl font-semibold mb-4">Question 8: Payments on Insider Debts</h2>
          <p className="text-sm text-gray-600 mb-4">
    List payments made on debts paid on behalf of an insider in the last year. Include payments on debts cosigned or guaranteed by an insider.
  </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {insiderDebts.map(item => {
            const tx = item.transactions?.[0] || {};
            return (
              <div
                key={item.id}
                className="relative p-4 bg-gray-100 shadow rounded cursor-pointer"
                onClick={() => openEditInsiderDebtModal(item)}
              >
                <button
                  onClick={e => { e.stopPropagation(); handleInsiderDebtDelete(item.id); }}
                  className="absolute top-2 right-2 text-red-600 hover:text-red-800"
                >
                  {/* Trash Icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" clipRule="evenodd" d="M6 2a1 1 0 00-1 1v1H3a1 1 0 000 2h14a1 1 0 000-2h-2V3a1 1 0 00-1-1H6zM4 6v10a2 2 0 002 2h8a2 2 0 002-2V6H4zm3 2a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2 0zm4 0a1 1 0 000 2v6a1 1 0 102 0V8a1 1 0 00-2 0z"/>
                  </svg>
                </button>
                <h3 className="font-medium">{item.insider_name}</h3>
                <p className="mt-2">
                  <span className="font-semibold">Address:</span> {item.street1}{item.street2 ? `, ${item.street2}` : ''}, {item.city}, {item.state} {item.zip_code}
                </p>
                {tx.payment_amount && (
                  <p className="mt-2">
                    <span className="font-semibold">Paid:</span> ${tx.payment_amount}
                  </p>
                )}
                <p className="mt-2">
                  <span className="font-semibold">Owing:</span> ${item.amount_owing}
                </p>
                {tx.payment_date && (
                  <p className="mt-2">
                    <span className="font-semibold">Date:</span> {tx.payment_date}
                  </p>
                )}
              </div>
            );
          })}
        </div>
        <button
          onClick={openInsiderDebtModal}
          className="mt-4 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
        >
          Add Insider Debt Payment
        </button>
      </section>
                            <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 4: Details about Legal Actions and Seizures</h2>
      </div>
      <LawsuitSection caseId={caseId} sofaResponse={sofaResponse} caseData={caseData} priorAddresses={priorAddresses} />
      <GarnishmentSection caseId={caseId} creditors={creditors}/>
      <SetoffSection caseId={caseId} sofaResponse={sofaResponse} creditors={creditors}/>
      <section className="p-6 bg-white shadow-lg rounded mb-6">
        <h2 className="text-xl font-semibold mb-4">Question 12: Property in Possession of Creditor</h2>
        <p className="text-sm text-gray-600 mb-4">
          List if property was in the possession of an assignee for the benefit of creditors, a court-appointed receiver, a custodian, or another official within the last year.
        </p>
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            className="form-checkbox text-indigo-600"
            checked={!!sofaResponse.property_in_possession_of_receiver}
            onChange={() => handleCheckboxChange('property_in_possession_of_receiver')}
          />
          <span>Property in Possession of Receiver</span>
        </label>
      </section>
                          <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 5: Details about Gifts and Contributions</h2>
      </div>
      <GiftSection caseId={caseId} sofaResponse={sofaResponse}/>
      <CharitySection caseId={caseId} sofaResponse={sofaResponse}/>
                          <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 6: Details about Losses</h2>
      </div>
      <LossSection caseId={caseId} sofaResponse={sofaResponse}/>
                          <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 7: Details about Certain Payments or Transfers</h2>
      </div>
      <AttorneyPayments caseId={caseId} sofaResponse={sofaResponse}/>
      <CreditorAgentSection caseId={caseId} sofaResponse={sofaResponse}/>
      <OtherTransactionsSection caseId={caseId} sofaResponse={sofaResponse}/>
      <TrustSection caseId={caseId} sofaResponse={sofaResponse}/>
                      <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 8: Details about Closed Accounts, Safety Deposit Boxes and Storage Units</h2>
      </div>
      <ClosedAccountsSection caseId={caseId} sofaResponse={sofaResponse}/>
      <SafetyDepositSection caseId={caseId} sofaResponse={sofaResponse}/>
      <StorageUnitsSection caseId={caseId} sofaResponse={sofaResponse}/>
                <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 9: Details about Property you Hold or Control for Someone Else</h2>
      </div>
      <BorrowedPropertySection caseId={caseId} sofaResponse={sofaResponse}/>
            <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 10: Details about Environmental Laws</h2>
      </div>
      <EnvViolationSection caseId={caseId} sofaResponse={sofaResponse}/>
      <GovHazmatReleaseSection caseId={caseId} sofaResponse={sofaResponse}/>
      <EnvLawsuitsSection caseId={caseId} sofaResponse={sofaResponse}/>
      <div className="text-center mb-4">
        <h2 className="text-2xl font-bold">Part 11: Details about your Businesses</h2>
      </div>
      <BusinessSection caseId={caseId} sofaResponse={sofaResponse} caseData={caseData}/>
      <FinancialStatementSection caseId={caseId} sofaResponse={sofaResponse}/>
      {/* Additional SOFA sections to be implemented similarly:
          - Assets
          - Liabilities
          - Transfers
          - Legal Actions
          - etc.
      */}
    </div>
  );
}
